import type { Component } from 'vue'

export const INFO_ROUTE_TYPES = {
  HighFrequencyGame: 'high_frequency_game',
  Lottery: 'lottery',
  Scratchcard: 'scratchcard',
} as const

export type InfoRouteMetaConfig = {
  header: Component
  param: string
  routes: InfoRouteNameConfig
  type: InfoRouteType
}

export type InfoRouteType = ObjectValues<typeof INFO_ROUTE_TYPES>

type InfoRouteNameConfig = { Faq: string; Prizes: string; Rules: string }

export const CUSTOM_INFO_ROUTES = {
  Faq: 'faq',
  Prizes: 'prizes',
  Rules: 'rules',
} as const

export const CUSTOM_INFO_ROUTE_NAMES_LOTTERY: InfoRouteNameConfig = {
  Faq: 'faqLottery',
  Prizes: 'prizesLottery',
  Rules: 'rulesLottery',
} as const

export const CUSTOM_INFO_ROUTE_NAMES_SCRATCHCARD: InfoRouteNameConfig = {
  Faq: 'faqScratchcard',
  Prizes: 'prizesScratchcard',
  Rules: 'rulesScratchcard',
} as const

export type CustomInfoRoute = ObjectValues<typeof CUSTOM_INFO_ROUTES>
